import { Component, OnInit } from '@angular/core';
import { IMoveContactUploadItem } from '../../../store/models/contact.model';
import { ITableColumn } from '../../../store/models/table.model';
import { StaticDataSource } from '../../../datasources/static.datasource';

@Component({
  selector: 'app-upload-confirmation-dialog',
  templateUrl: './upload-confirmation-dialog.component.html',
  styleUrls: ['./upload-confirmation-dialog.component.scss'],
})
export class UploadConfirmationDialogComponent implements OnInit {
  items: IMoveContactUploadItem[] = [];

  tableColumns: ITableColumn<IMoveContactUploadItem>[] = [
    {
      id: 'account_id',
      title: 'Source Account ID',
    },
    {
      id: 'contact_account_id',
      title: 'Destination Account ID',
    },
    {
      id: 'contact_email',
      title: 'Email',
    },
    {
      id: 'contact_id',
      title: 'Contact ID',
    },
    {
      id: 'destination_group',
      title: 'Destination Group',
      renderer: (item: IMoveContactUploadItem) => {
        return (
          (item.destination_group || '') +
          (item.group_to ? ` (${item.group_to})` : '')
        );
      },
    },
    {
      id: 'error',
      title: 'Status',
      renderer: (item: IMoveContactUploadItem) => {
        return item.error ? 'Failed: ' + item.error : 'Success';
      },
    },
  ];

  dataSource: StaticDataSource<IMoveContactUploadItem>;

  constructor() {}

  ngOnInit(): void {
    if (this.items && this.items.length) {
      this.dataSource = new StaticDataSource<IMoveContactUploadItem>(
        this.items
      );
    }
  }
}
